import { useContext } from 'react';
import { BrandContext } from './BrandProvider';
import type { BrandConfig } from './brands';

/**
 * The active brand's configuration. Always read the brand from here —
 * never hardcode 'Numtable' or 'Procalendar' in a component.
 */
export function useBrand(): BrandConfig {
  const config = useContext(BrandContext);
  if (!config) throw new Error('useBrand must be used inside <BrandProvider>');
  return config;
}
